import { QueryClient } from '@tanstack/react-query'

import { isRetryableError } from './http'

/**
 * Module-level QueryClient singleton. Shared by both the QueryClientProvider
 * (so components can call `useQueryClient()`) and the TanStack Router context
 * (so route `beforeLoad` / `loader` can prefetch against the same cache the
 * components read from).
 *
 * Defaults follow the plan's data-fetching policy:
 *   - 30s staleTime for lists (snappy admin operations).
 *   - 5min gcTime so navigations within the session don't refetch.
 *   - retry only idempotent failures, capped at 2 attempts. Mutations never
 *     auto-retry (decided per-mutation).
 *   - refetchOnWindowFocus on lists (operators bounce between tabs while
 *     handling tickets); detail pages opt-out per-query when they have an
 *     in-flight edit.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) =>
        failureCount < 2 && isRetryableError(error),
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: false,
    },
  },
})
